<template>
  <v-container class="pa-0" fluid>
    <common-error
      v-if="isErrorGetTransportTypeLimit"
      @fetchData="isErrorGetTransportTypeLimit = false"
    />
    <v-row v-else class="mb-4">
      <v-col cols="12">
        <v-data-table
          item-key="id"
          class="elevation-1"
          :loading="isLoading"
          :headers="displayedHeaderLocation"
          :items="mouTransportTypeLimit"
          :footer-props="{showCurrentPage: true, showFirstLastPage: true, 'items-per-page-options': $_item_per_page}"
          :options.sync="pagination"
          :server-items-length="totalData"
        >
          <template v-slot:[`item.unitLimit`]="{item}">
            <div class="d-flex">
              <v-text-field
                dense
                outlined
                v-mask="{'alias': 'integer', allowMinus: false, rightAlign: false}"
                class="body-2 pt-2"
                disabled
                v-model="item.unitLimit"
              ></v-text-field>
            </div>
          </template>
          <template v-slot:[`item.limits`]="{item}">
            <div class="d-flex">
              <v-text-field
                dense
                outlined
                v-mask="{'alias': 'integer', allowMinus: false, rightAlign: false}"
                class="body-2 pt-2"
                v-model="item.limits"
                disabled
              ></v-text-field>
            </div>
          </template>
          <template v-slot:[`item.typeTransporter`]="{item}">
            <v-text-field
              dense
              outlined
              class="body-2 pt-2"
              :value="item.transportTypeName"
              disabled
            ></v-text-field>
          </template>
          <template v-slot:[`item.interval`]="{item}">
            <v-select
              :items="itemsInterval"
              item-text="name"
              item-value="value"
              v-model="item.interval"
              dense
              disabled
              class="body-2 pt-2"
              outlined
            ></v-select>
          </template>
          <template v-slot:[`item.price`]="{item}">
            <v-text-field
              dense
              :value="formatAsCurrency(item.price)"
              outlined
              prefix="Rp"
              disabled
              class="body-2 pt-2"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'fixed-price-page',
  data() {
    return {
      isLoading: false,
      isErrorGetTransportTypeLimit: false,
      itemsInterval: [
        {
          name: 'Bulanan',
          value: 'MONTHLY',
        },
        {
          name: 'Mingguan',
          value: 'WEEKLY',
        },
      ],
      headersTableFixedPrice: [
        {
          text: this.$_strings.mou.TRANSPORT_TYPE,
          value: 'typeTransporter',
          width: '20vw',
          sortable: false,
        },
        {
          text: this.$_strings.mou.NUMBER_OF_UNIT,
          value: 'unitLimit',
          width: '10vw',
          sortable: false,
        },
        {
          text: this.$_strings.mou.NUMBER_OF_LIMIT,
          value: 'limits',
          width: '15vw',
          sortable: false,
        },
        {
          text: this.$_strings.mou.INTERVAL,
          value: 'interval',
          sortable: false,
        },
        {
          text: this.$_strings.mou.PRICE_INTERVAL,
          value: 'price',
          sortable: false,
        },
      ],
      totalData: 0,
      pagination: {
        page: 1,
        itemsPerPage: 10,
      },
      mouTransportTypeLimit: [],
    };
  },
  computed: {
    displayedHeaderLocation() {
      return this.headersTableFixedPrice.map((i) => ({
        ...i,
        class: 'white--text primary text-capitalize',
        cellClass: 'clickable',
      }));
    },
    mouBy() {
      const [,, path] = this.$route.path.split('/');
      if (path === 'customer') return 'shipper';
      return 'transporter';
    },
  },
  watch: {
    pagination: {
      handler() {
        this.fetchMouTransportTypeLimit();
      },
      deep: true,
    },
  },
  methods: {
    async fetchMouTransportTypeLimit() {
      const { mouId } = this.$route.params;
      const { page, itemsPerPage: size } = this.pagination;
      const filters = {
        page: page - 1,
        size,
      };
      try {
        this.isLoading = true;
        this.isErrorGetTransportTypeLimit = false;
        const result = await this.$_services.mou.getMouTransportTypeLimit(filters, { mouBy: this.mouBy, mouId });
        this.totalData = result.data.totalData;
        this.mouTransportTypeLimit = result.data.contents;
      } catch {
        this.isErrorGetTransportTypeLimit = true;
      } finally {
        this.isLoading = false;
      }
    },
    formatAsCurrency(value) {
      const formatNumber = Intl.NumberFormat('id-ID');
      return formatNumber.format(value) || 0;
    },
  },
};

</script>
